import React, { ReactNode } from 'react';
import { Toolbar } from '@mui/material';

interface CustomToolbarProps {
  children: ReactNode; // To render any content (buttons, etc.) inside the toolbar
  direction?: 'row' | 'column'; // Allow specifying row or column layout
}

const CustomToolbar: React.FC<CustomToolbarProps> = ({ children, direction = 'column' }) => {
  return (
    <Toolbar sx={{ display: 'flex', minHeight:'100%', flexDirection: direction, alignItems: 'center' }}>
      {children}
    </Toolbar>
  );
};

export default CustomToolbar;